const hasRole = (roles, userType) => {
    if (!Array.isArray(roles)) return true
    return roles.includes(normalizeProcessUserType(userType))
}

export const normalizeProcessUserType = (userType) => {
    if (userType === 'employee') return 'admin'
    return userType || 'observer'
}

export const canViewProcessStage = (stage, userType) => {
    if (!stage) return false
    return hasRole(stage.statusVisibleFor, userType)
}

export const canManageProcessStage = (stage, userType) => {
    if (!stage) return false
    return hasRole(stage.statusVisibleFor, userType)
}

export const canAdvanceFromProcessStage = (stage, userType) => {
    if (!stage) return false
    return hasRole(stage.advanceFor, userType)
}

export const canEditProcessStage = (
    stage,
    userType,
    hasAdminEditPermission = false
) => {
    if (!stage) return false

    const normalizedUserType = normalizeProcessUserType(userType)
    if (normalizedUserType === 'admin') {
        return Boolean(hasAdminEditPermission)
    }

    return Array.isArray(stage.advanceFor)
        && stage.advanceFor.includes(normalizedUserType)
}

export const getNextProcessStageKey = (stages, currentKey) => {
    const stageKeys = Object.keys(stages || {})
    if (stageKeys.length === 0) return null
    if (!currentKey) return stageKeys[0]

    const currentIndex = stageKeys.indexOf(currentKey)
    if (currentIndex < 0 || currentIndex >= stageKeys.length - 1) return null
    return stageKeys[currentIndex + 1]
}

export const canTransitionToNextProcessStage = (
    stages,
    currentKey,
    userType,
    hasRequiredPermission = () => true
) => {
    const nextKey = getNextProcessStageKey(stages, currentKey)
    if (!nextKey) return false

    const nextStage = stages?.[nextKey]

    // advanceFor belongs to the destination stage: it defines which roles may
    // enter that stage, regardless of who owned the stage being completed.
    if (!canAdvanceFromProcessStage(nextStage, userType)) return false
    if (nextStage?.requiredPermission && !hasRequiredPermission(nextStage.requiredPermission)) return false

    return true
}

export const getRecordProcessStageKey = (record) => {
    const currentStatus = record?.values?.currentStatus ?? record?.currentStatus
    const legacyStage = record?.values?.currentStage || record?.currentStage

    if (currentStatus && typeof currentStatus === 'object') {
        return currentStatus.key || legacyStage || currentStatus.value || null
    }
    if (typeof currentStatus === 'string') {
        return currentStatus
    }

    return legacyStage || null
}
